export default "__VITE_ASSET__D8Xn8NKS__"